/**
 * The way back from Ember games' yard into a conversation (2026-10-23 Riley;
 * the games live in Oriscen/ember-games, games/yard). The yard is where
 * people let off steam, every line reworded before anyone sees it; its doors
 * to Ember land on /talk?mode=chat&yard=<door>&tag=<tag> — carrying which
 * door was pressed and which tag the rewording gave the person's lines (boss,
 * ex, work …) — and the line the conversation opens on is written here from
 * those two. Since 2026-10-31 (Riley) the `line` door may also bring the
 * person's own starred words, in the URL fragment (never to a server): then
 * the chat opens on nothing and those words wait in the field as their draft
 * (YardTalkHandoff.tsx), and no line is written here.
 *
 * The doors (ember-games games/yard/web/YardParts.tsx yardTalkHref). Current:
 *   line      "Say the rest to Ember", under one of the person's own lines
 *   board     "Ember" on a Waste Yard card, with the card's tag
 *   risk      the card the Purifier shows them alone when a line carried a risk
 *   composer  the manual's "Want to actually feel better?"
 * Kept for links already out there (the 2026-10-23 room had them):
 *   overflow  the TOXICITY_OVERFLOW dialog of the old meter
 *   card      the old board's card on their own night
 *
 * The tag list is the yard's (games/yard/purify.js TAGS); the phrases are the
 * yard's too (games/yard/tags.js), in the first person here.
 */

export const YARD_HANDOFF_DOORS = Object.freeze(['composer', 'line', 'overflow', 'card', 'board', 'risk']);

/** How a tag reads in the person's own mouth: "my boss", "a coworker", "work". */
export const YARD_TAG_PHRASES = Object.freeze({
  boss: 'my boss', coworker: 'a coworker', work: 'work', customer: 'a customer', customer_service: 'customer service',
  landlord: 'my landlord', hoa: 'my HOA', roommate: 'my roommate', neighbor: 'a neighbor',
  partner: 'my partner', ex: 'my ex', dating: 'dating', friend: 'a friend', parents: 'my parents', kids: 'my kids',
  in_laws: 'my in-laws', family: 'my family', school: 'school', money: 'money', bank: 'my bank', insurance: 'my insurance',
  healthcare: 'healthcare', airline: 'an airline', delivery: 'a delivery', car: 'my car', traffic: 'traffic',
  weather: 'the weather', social_media: 'social media', my_team: 'my team', stranger: 'a stranger',
  myself: 'myself',
});

/** The first line of the conversation for a yard link, or '' when the link names no door we know. */
export function yardTalkLine(door, tag) {
  const d = String(door || '');
  if (!YARD_HANDOFF_DOORS.includes(d)) return '';
  const t = String(tag || '');
  // Own keys only: a tag of 'constructor' or 'toString' read Object's own and put a function in the line.
  const about = Object.prototype.hasOwnProperty.call(YARD_TAG_PHRASES, t) ? YARD_TAG_PHRASES[t] : '';
  switch (d) {
    case 'composer':
      return 'I’ve been letting off steam in the yard tonight and I’m tired of it. I want to actually talk about what’s going on.';
    case 'line':
      return about
        ? `I just vented about ${about} in the yard. There’s more to it than that one line.`
        : 'I just vented in the yard. There’s more to it than that one line.';
    case 'overflow':
      return about
        ? `I’ve been letting off steam in the yard about ${about} and the meter maxed out. I’d rather actually talk about it.`
        : 'I’ve been letting off steam in the yard and the meter maxed out. I’d rather actually talk about what’s eating me.';
    case 'card':
      return about
        ? `I’ve said a lot about ${about} tonight in the yard. I’d rather talk about it properly.`
        : 'I’ve said a lot in the yard tonight. I’d rather talk about it properly.';
    case 'board':
      return about
        ? `${about.charAt(0).toUpperCase()}${about.slice(1)} too. I want to talk about it.`
        : 'I saw what everyone else is dealing with and I want to talk about mine.';
    case 'risk':
      return 'Something I wrote in the yard set off a warning. I’m not okay tonight and I want to talk.';
    default:
      return '';
  }
}
